import type {KAError} from "./ka-error.ts";
import type {ErrorWithResponse} from "./types";

/**
 * Checks if the given KAError is an instance of ErrorWithResponse.
 *
 * @param err The error to check.
 * @returns `true` if the error is an instance of ErrorWithResponse,
 * `false` otherwise.
 */
export function isErrorWithResponse(err: KAError): err is ErrorWithResponse {
    return (
        typeof err === "object" &&
        err != null &&
        "response" in err &&
        typeof err.response === "object" &&
        err.response != null
    );
}
